
<div class="simpleSearchShop">
  <form class="ui big form" @submit.prevent="search()">
    <div class="four fields">
      <div class="field">
        <dropdown v-model="model.prefecture" :placeholder="'エリア'" class="fluid">
          <option v-for="each in consts.SIMPLE_SEARCH_SHOP_AREA" :key="each.label" :value="each.value" :disabled="each.value === ''">{{ each.label }}</option>
        </dropdown>
      </div>
      <div class="field">
        <dropdown v-model="model.people_from" :placeholder="'人数'" class="fluid">
          <option v-for="each in consts.SHOP_PEOPLE" :key="each.label" :value="each.value">{{ each.label }}～</option>
        </dropdown>
      </div>
      <div class="field">
        <dropdown v-model="model.price_to" :placeholder="'予算'" class="fluid">
          <option value="3000">～3,000円</option>
          <option value="4000">～4,000円</option>
          <option value="5000">～5,000円</option>
          <option value="6000">～6,000円</option>
          <option value="7000">～7,000円</option>
          <option value="8000">～8,000円</option>
          <option value="9000">～9,000円</option>
          <option value="10000">～10,000円</option>
          <option value="10001">10,000円～</option>
        </dropdown>
      </div>
      <div class="field">
        <button class="ui fluid orange big button">
          <i class="fas fa-search"></i> 検索する
        </button>
      </div>
    </div>
  </form>
</div>
